// Theme configuration for the application
const themes = {
  default: {
    colors: {
      primary: '#1890ff',
      secondary: '#f0f0f0',
      success: '#52c41a',
      warning: '#faad14',
      error: '#f5222d',
      text: '#000000d9',
      textSecondary: '#00000073',
      background: '#ffffff',
      border: '#d9d9d9',
    },
    spacing: {
      xs: '4px',
      sm: '8px',
      md: '16px',
      lg: '24px',
      xl: '32px',
    },
    borderRadius: {
      small: '2px',
      medium: '6px',
      large: '8px',
    },
    typography: {
      fontSize: {
        small: '12px',
        base: '14px',
        large: '16px',
        xlarge: '20px',
      },
      fontWeight: {
        normal: 400,
        medium: 500,
        bold: 600,
      },
    },
  },
  dark: {
    colors: {
      primary: '#177ddc',
      secondary: '#303030',
      success: '#49aa19',
      warning: '#d89614',
      error: '#d32029',
      text: '#ffffffd9',
      textSecondary: '#ffffff73',
      background: '#141414',
      border: '#434343',
    },
    spacing: {
      xs: '4px',
      sm: '8px',
      md: '16px',
      lg: '24px',
      xl: '32px',
    },
    borderRadius: {
      small: '2px',
      medium: '6px',
      large: '8px',
    },
    typography: {
      fontSize: {
        small: '12px',
        base: '14px',
        large: '16px',
        xlarge: '20px',
      },
      fontWeight: {
        normal: 400,
        medium: 500,
        bold: 600,
      },
    },
  },
};

export default themes;
